import { createFileRoute } from "@tanstack/react-router";

import { LegalPage } from "@/web/routes/-legal/LegalPage";
import termsHtml from "@/web/routes/-legal/terms.md?html";
import { appUrl } from "@/web/lib/siteUrls";

const DESCRIPTION =
  "The terms of use governing your use of WITH.CO's website, products, and services.";

export const Route = createFileRoute("/terms")({
  ssr: true,
  head: () => ({
    meta: [
      { title: "Terms of Use — WITH.CO" },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: "Terms of Use — WITH.CO" },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: appUrl("/terms") },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => <LegalPage title="Terms of Use" html={termsHtml} />,
});
